export const formatDate = (date: string): string | null =>
  (date && new Date(date).toLocaleDateString().replaceAll('/', '-')) || null
